<template>
  <div id="DepartmentChairManage">
    <div  class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click="UpdateDepartmentChair()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
        更新系主任名單
        </button>
        <button
          href="#"
          @click="UpdateDepartmentChair2()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
        更新一二級主管名單
        </button>
      </div>

      <b-tabs content-class="mt-3" justified >
        <b-tab title="教學單位" active v-if="DepartmentChairManageShow">
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
        目前系主任名單共 {{ total }}筆
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 1em">學年</b-th>
                <b-th style="min-width: 1em">學期</b-th>
                <b-th style="min-width: 1em">系ID</b-th>
                <b-th style="min-width: 1em">學院ID</b-th>
                <b-th style="min-width: 5em">系名</b-th>
                <b-th style="min-width: 1em">職稱</b-th>
                <b-th style="min-width: 20em">姓名</b-th>
                <b-th style="min-width: 2em">員工編號</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.did"
                :index="item.did"

                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
              <b-td style="text-align: left">
                  {{ item.schyy }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.smt }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.depid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.parent_node }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.depid_name }}
                </b-td>
                <b-td style="text-align:left">
                  {{ item.eiprl_name }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.eiprc_name }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.workid }}
                </b-td>

              </b-tr>
            </b-tbody>

          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />

        </div>
        </b-tab>

        <b-tab title="全校單位"  v-if="!DepartmentChairManageShow">
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
        目前一二級主管名單共 {{ total2 }}筆
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 1em">學年</b-th>
                <b-th style="min-width: 1em">學期</b-th>
                <b-th style="min-width: 1em">單位ID</b-th>
                <b-th style="min-width: 1em">上級單位ID</b-th>
                <b-th style="min-width: 5em">現職單位名稱</b-th>
                <b-th style="min-width: 5em">原單位名稱</b-th>
                <b-th style="min-width: 1em">職稱</b-th>
                <b-th style="min-width: 20em">姓名</b-th>
                <b-th style="min-width: 2em">員工編號</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs2"
                :key="item.did"
                :index="item.did"

                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
              <b-td style="text-align: left">
                  {{ item.schyy }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.smt }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.depid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.parent_node }}
                </b-td>

                <b-td style="text-align:left">
                  {{ item.name }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.depid_name }}
                </b-td>
                <b-td style="text-align:left">
                  {{ item.eiprl_name }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.eiprc_name }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.workid }}
                </b-td>

              </b-tr>
            </b-tbody>

          </b-table-simple>
          <b-pagination
            v-model="currentPage2"
            :total-rows="total2"
            :per-page="pageSize"
            :limit="21"
            v-if="total2 > pageSize"
          />

        </div>
        </b-tab>


      </b-tabs>




    </div>
  </div>
</template>


<script>

import * as tools from "../tool";
export default {
  name: "DepartmentChairManage",

  data() {
    return {
      courseName: null,
      DepartmentChairManageShow: true,
      sn: 0,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,

      pageSize: 100,
    };
  },

  methods: {

    getAllDepartmentChair() {
  let vm = this;
  this.$http
    .get("./WebApi/HighSchoolEnrolling/GetAllDepartmentChair/")
    .then((response) => {
      if (!tools.isNull(response)) {
        vm.inputData = response.data;
        vm.total = vm.inputData.length;
      }
    })
    .catch(function (error) {
      alert("網路連線失敗" + error);
    });
},
UpdateDepartmentChair() {
  let vm = this;
  vm.DepartmentChairManageShow = true;
  this.$http
    .get("./WebApi/HighSchoolEnrolling/UpdateDepartmentChair/")
    .then((response) => {
      if (!tools.isNull(response)) {
        vm.inputData = response.data;
        vm.total = vm.inputData.length;
        tools.showAlert(vm, "success", "更新成功");
      }
    })
    .catch(function (error) {
      alert("網路連線失敗" + error);
    });
},
UpdateDepartmentChair2() {
  let vm = this;
  vm.DepartmentChairManageShow = false;
  this.$http
    .get("./WebApi/HighSchoolEnrolling/UpdateDepartmentChair2/")
    .then((response) => {
      if (!tools.isNull(response)) {
        vm.inputData2 = response.data;
        vm.total2 = vm.inputData2.length;
        tools.showAlert(vm, "success", "更新成功");
      }
    })
    .catch(function (error) {
      alert("網路連線失敗" + error);
    });
},




  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created DepartmentChairManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.DepartmentChairManageShow = true;
    vm.getAllDepartmentChair();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
